import { render, staticRenderFns } from "./ProjectTemplateLinksManager.vue?vue&type=template&id=fa30d364"
import script from "./ProjectTemplateLinksManager.vue?vue&type=script&lang=ts"
export * from "./ProjectTemplateLinksManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports